import React from 'react';

const CustomInput = ({
    id,
    name,
    label,
    type = "text",
    value,
    onChange,
    onBlur,
    placeholder,
    error,
    touched,
    isTextarea = false, // Додаємо прапорець для textarea
    readOnly = false,
    disabled = false,
}) => {
    const InputElement = isTextarea ? "textarea" : "input";
    const hasError = Boolean(touched && error);

    // Prevent the mouse wheel from changing the value of number inputs
    // (native browser behaviour) — blur so the wheel scrolls the page instead.
    const handleWheel = type === "number" ? (e) => e.currentTarget.blur() : undefined;

    return (
        <div className="form-group">
            {label && <label htmlFor={id}>{label}</label>}

            <div className="input-wrapper">
                <InputElement
                    id={id}
                    name={name}
                    type={isTextarea ? undefined : type}
                    onChange={onChange}
                    onBlur={onBlur}
                    onWheel={handleWheel}
                    value={value}
                    readOnly={readOnly}
                    disabled={disabled}
                    className={`form-control ${hasError ? 'error' : ''}`}
                    placeholder={placeholder}
                />
            </div>
            
            {/* Відображення помилки */}
            {touched && error ? (
                <div className="error-text">
                    {error}
                </div>
            ) : null}
        </div>
    );
};

export default CustomInput;